import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@shared/components/base.component';

@Component({
  selector: 'app-ambassador-tooltip',
  templateUrl: './ambassador-tooltip.component.html',
  styleUrls: ['./ambassador-tooltip.component.scss'],
})
export class AmbassadorTooltipComponent extends BaseComponent {
  @Input() ambassador: any;

  constructor(public router: Router) {
    super();
  }

  goToProfile(id: number) {
    this.router.navigate([`/profile/${id}/verified`]);
  }
}
